module.exports = __webpack_public_path__ + "img/40_00_000_330.2ec5cf72.jpg";